import { Pipe, PipeTransform } from '@angular/core';
import { differenceInSeconds, isAfter } from 'date-fns';

const minute = 60;
const hour = minute * 60;
const day = hour * 24;
const week = day * 7;
const month = day * 30;
const year = day * 365;

@Pipe({
  name: 'relativeDate',
})
export class RelativeDatePipe implements PipeTransform {
  transform(
    value: Date | null | undefined,
    compare: Date = new Date(),
  ): string {
    if (!value) {
      return '';
    }

    const diff = Math.abs(differenceInSeconds(value, compare));
    const text = this.formatText(diff);

    if (isAfter(value, compare)) {
      return `in ${text}`;
    }

    return `${text} ago`;
  }

  private formatText(diff: number): string {
    if (diff < hour) {
      return this.pluralize(Math.floor(diff / minute), 'minute', 'minutes');
    }

    if (diff < day) {
      return this.pluralize(Math.floor(diff / hour), 'hour', 'hours');
    }

    if (diff < week) {
      return this.pluralize(Math.floor(diff / day), 'day', 'days');
    }

    if (diff < month) {
      return this.pluralize(Math.floor(diff / week), 'week', 'weeks');
    }

    if (diff < year) {
      return this.pluralize(Math.floor(diff / month), 'month', 'months');
    }

    return 'more than a year';
  }

  private pluralize(value: number, singular: string, plural: string): string {
    return `${value} ${value === 1 ? singular : plural}`;
  }
}
